import { connect } from 'react-redux';
import JoditEditor from 'jodit-react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styles from './TextEditor.scss';
import { configuratorProps } from './Configurator';
import { getMergedClassNames } from '../../utils/HTMLUtils';

const rootClassName = styles.rootClassName;

export const TEXT_EDITOR_TD_STYLE = 'border: 1px solid #000 !important;';

class TextEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editorRef: React.createRef(),
      config: this.getConfig(props),
      value: props.value,
      placeholder: this.props.placeholder,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      config: this.getConfig(nextProps),
      value: nextProps.value,
      placeholder: nextProps.placeholder,
    });
  }

  onChange = (value) => {
    if (typeof value === 'string') {
      this.setState({ value: value });
    }
  };

  getConfig = (props) => {
    let config = { ...configuratorProps };
    let beforeButtons =
      props.beforeCustomButtons && props.beforeCustomButtons.length > 0
        ? props.beforeCustomButtons
        : [];
    let afterButtons =
      props.afterCustomButtons && props.afterCustomButtons.length > 0
        ? props.afterCustomButtons
        : [];

    if (config.buttons.indexOf('font') > -1) {
      config.buttons.splice(config.buttons.indexOf('font'), 1);
    }

    if (typeof this.props.onChange === 'function') {
      config.events = {
        ...(config.events || {}),
        blur: () => {
          this.props.onChange(this.state.value);
        },
      };
    }

    if (beforeButtons.length > 0) {
      config.buttons = ['|', ...beforeButtons, ...config.buttons];
    }

    if (afterButtons.length > 0) {
      config.buttons = ['|', ...config.buttons, ...afterButtons];
    }

    config.disabled =
      typeof props.disabled === 'boolean' && props.disabled ? true : false;

    return config;
  };

  getEditor = () => {
    return (
      <>
        <JoditEditor
          className={rootClassName + '-editor'}
          editorRef={this.setRef}
          value={this.state.value}
          config={this.state.config}
          onChange={(value) => this.onChange(value)}
        />
        {typeof this.props.actionButtons === 'function'
          ? this.props.actionButtons(this.state.value)
          : null}
      </>
    );
  };

  render() {
    return (
      <div
        className={getMergedClassNames([
          rootClassName,
          this.props.className || '',
          this.props.withoutBorder ? rootClassName + '-without-border' : '',
        ])}
      >
        {this.getEditor()}
      </div>
    );
  }
}

TextEditor.propTypes = {
  className: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  beforeCustomButtons: PropTypes.arrayOf(PropTypes.object),
  afterCustomButtons: PropTypes.arrayOf(PropTypes.object),
  disabled: PropTypes.bool,
  actionButtons: PropTypes.func,
  withoutBorder: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TextEditor);
